import classNames from "classnames";
import React from "react";

import SectionTag from "@/components/table/shared/SectionTag";
import { Section } from "@/stores/types/section-tags";

import arrowUp from "../../../images/table-image/icon/arrow-up.svg";
import SectionPopupSettings from "./SectionPopupSettings";
import Sharing from "./Sharing";

type SectionDropdownTitleProps = {
  title: string;
  archived?: boolean;
  isOpen: boolean;
  onToggleOpen: () => void;
  isEdittable?: boolean;
  isEditMode?: boolean;
  setIsEditMode?: React.Dispatch<React.SetStateAction<boolean>>;
  onDelete?: () => void;
  canManageSections?: boolean;
  tableName?: string;
  moduleWorkspaceId?: string;
  sectionTag?: Section;
  rolePrefix?: string;
};

const SectionDropdownTitle = (props: SectionDropdownTitleProps) => {
  // Functions
  const onRename = () => {
    props.setIsEditMode?.(true);
  };

  return (
    <div
      className={classNames("dropdown-title-wrap", {
        "archived-title-wrap": props.archived,
      })}
      data-testid="section-title"
    >
      <div
        className={classNames("dropdown-title", {
          "dropdown-open": props.isOpen,
        })}
      >
        <div className="dropdown-title-block">
          <div className="dropdown-title-click" data-testid="hide-section">
            <div
              className="dropdown-arrow"
              onClick={props.onToggleOpen}
              data-testid="hide-section-button"
            >
              <img src={arrowUp} alt="dropdown-arrow" />
            </div>
            {props.title && (
              <SectionTag
                isEditMode={props.isEditMode as boolean}
                setIsEditMode={
                  props.setIsEditMode as React.Dispatch<
                    React.SetStateAction<boolean>
                  >
                }
                sectionTagID={props.sectionTag?.id as number}
                sectionTagTitle={props.title as string}
                dataTestID={`${props.rolePrefix}-heading`}
              />
            )}
          </div>
          {props.isEdittable && (
            <div className="dropdown-public-block">
              {props.canManageSections && (
                <Sharing
                  // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
                  moduleWorkspaceID={props.moduleWorkspaceId}
                  // @ts-expect-error TS(2322) FIXME: Type 'number | null | undefined' is not assignable... Remove this comment to see the full error message
                  objectID={props.sectionTag?.id}
                  selectedDepartmentIDs={props.sectionTag?.department_ids}
                  selectedUserIDs={props.sectionTag?.user_ids}
                  tableName={props.tableName}
                  allowSharing
                />
              )}
              {props.canManageSections && (
                <SectionPopupSettings
                  onRename={onRename}
                  onDelete={props.onDelete}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionDropdownTitle;
